// Puerto del dominio (repository abstracto) para la validación de cúmulo.
import { Observable } from 'rxjs';
import { CumuloValidationInput, CumuloValidationResult } from '../../interfaces/cumulo/cumulo.interface';

export abstract class CumuloRepository {
  abstract validate(input: CumuloValidationInput): Observable<CumuloValidationResult>;
}
